// extracted by mini-css-extract-plugin
export default {"container":"alert_container__HVbTG","antdAlertCustomStyling":"alert_antdAlertCustomStyling__aLyR6"};